<template>
  <div class="input-panel panel-start">    
    <form class="panel-start__form">
      <div class="panel-start__row">
        <div class="panel-start__col">
          <h2 class="input-panel__head">Start Month</h2>
          <div class="panel-start__months">
            <fieldset class="radio-button"
              v-for="month in months"
            >
              <input type="radio" name="start-month" 
                :id="month.name"
                :disabled="!month.active"
                :value="month.num"
                v-model="selected.month"
                @change="validateYears(false)"
              >
              <label :for="month.name">{{ month.name }}</label>
            </fieldset>
          </div><!--/.panel-start__months-->
        </div><!--/.panel-start__col-->
        <div class="panel-start__col">
          <h2 class="input-panel__head">Start Year</h2>
          <div class="panel-start__years">
            <fieldset class="radio-button"
              v-for="year in years"
            >
              <input type="radio" name="start-year" 
                :id="yearId(year)"
                :disabled="!validYear(year)"
                :value="year"
                v-model="selected.year"
                @change="setDate"
              >
              <label :for="yearId(year)">{{ year }}</label>
            </fieldset>
          </div><!--/.panel-start__years-->
        </div><!--/.panel-start__col-->
      </div><!--/.panel-start__row-->
    </form>
  </div>
</template>

<script>
//import moment from 'moment'
import * as moment from 'moment-timezone';
import swal from 'sweetalert'

moment.tz.setDefault('Etc/UTC')

export default {
  data() {
    return {
      months: [
        {
          name: 'January',
          num: 1,
          active: true
        },
        {
          name: 'February',
          num: 2,
          active: true
        },
        {
          name: 'March',
          num: 3,
          active: true
        },
        {
          name: 'April',
          num: 4,
          active: true
        },
        {
          name: 'May',
          num: 5,
          active: true
        },
        {
          name: 'June',
          num: 6,
          active: true
        },
        {
          name: 'July',
          num: 7,
          active: true
        },
        {
          name: 'August',
          num: 8,
          active: true
        },
        {
          name: 'September',
          num: 9,
          active: true
        },
        {
          name: 'October',
          num: 10,
          active: true
        },
        {
          name: 'November',
          num: 11,
          active: true
        },
        {
          name: 'December',
          num: 12,
          active: true
        }
      ],
      invalidYears: [],
      selected: {
        month: '',
        year: ''
      }
    }
  },
  computed: {
    startMonth() {
      return this.$store.getters.startMonth
    },
    utilityPlan() {
      return this.$store.getters.utilityPlan
    },
    now() {
      return moment()
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    years() {
      const now = moment()

      let years = [now.format('YYYY')]
      let months = 60

      for (var i = 0; i < months; i++) {
        let nextYear = now.add(1, 'months').format('YYYY')
        if (years.indexOf(nextYear) < 0) {
          years.push(nextYear)
        }
      }

      return years
    },
    selectedTimestamp() {
      if (this.selected.month && this.selected.year) {
        const date = this.selected.year + '-' + ("0" + this.selected.month).slice(-2) + '-' + '01'
        return moment(date)
      }
    },
    customFacilityProfile() {
      return this.$store.getters.customFacilityProfile
    },
    tempCustomFacilityProfile() {
      return this.$store.getters.tempCustomFacilityProfile
    },
    customFacilityProfileSet() {
      if (Object.keys(this.customFacilityProfile).length > 0) {
        return true
      }

      return false
    },
    tempcustomFacilityProfileSet() {
      if (Object.keys(this.tempCustomFacilityProfile).length > 0) {
        return true
      }

      return false
    },
    termLength() {
      return this.$store.getters.termLength
    },
    activeTerms() {
      var activeTerms = this.termLength
      activeTerms = activeTerms.filter(function(item) {
        return item.value != ''
      })
      return activeTerms
    },
    longestTermLength() {   
      const longestTerm = this.activeTerms.sort(function(a, b) {
        if (parseInt(a.value) < parseInt(b.value)) {
          return 1;
        } else {
          return -1;
        }
      })

      if (longestTerm.length) {
        return parseInt(longestTerm[0].value)
      
      } else if (this.customFacilityProfile.months) {
        return this.customFacilityProfile.months.length
      
      } else if (this.tempCustomFacilityProfile.months) {
        return this.tempCustomFacilityProfile.months.length
      }
    }
  },
  methods: {
    yearId(year) {
      return `y-${year}`
    },
    validYear(year) {
      if (this.selected.month && this.invalidYears.indexOf(year) < 0) {
        return true
      }

      return false
    },    
    validateYears(preserveYearSelection) {
      this.invalidYears = []

      if (!preserveYearSelection) {
        this.selected.year = ''
      }

      if (this.selected.month <= moment(this.now).format('M')) {
        this.invalidYears.push(moment(this.now).format('YYYY'))
      } 

      // Utility Plan Restrictions 
      // (based on lack of ability to create custom terms within 60 month window)
      if (this.planConfig.restrictStartMonth) {

        // Last selectable month:
        let lastValidMonth = moment().add(49, 'months').format('YYYY-MM-DD') // ?

        for (var i = 0; i < this.years.length; i++) {
          // For each selectable year, check to see whether the selected month/year would fall after the last valid month.

          // The equivelant month in the current year:
          let relativeMonth = moment(this.years[i] + '-' + ("0" + this.selected.month).slice(-2) + '-' + '01').format('YYYY-MM-DD')

          // If it's after, invalidate the associated year.
          if (moment(relativeMonth).isAfter(lastValidMonth)) {
             this.invalidYears.push(moment(relativeMonth).format('YYYY'))
          }
        }

      } else if (['premium', 'premium-legacy-1'].includes(this.utilityPlan.slug)) {
        // Last selectable month:
        let lastValidMonth = moment().add(60, 'months').format('YYYY-MM-DD') // ?

        for (var i = 0; i < this.years.length; i++) {
          // For each selectable year, check to see whether the selected month/year would fall after the last valid month.
          // The equivelant month in the current year:
          let relativeMonth = moment(this.years[i] + '-' + ("0" + this.selected.month).slice(-2) + '-' + '01').format('YYYY-MM-DD')

          // If it's after, invalidate the associated year.
          if (moment(relativeMonth).isAfter(lastValidMonth)) {
             this.invalidYears.push(moment(relativeMonth).format('YYYY'))
          }
        }
      }
    },
    getMonthRange(startMonth) {
      startMonth = new moment(startMonth)

      let endMonth = new moment(startMonth).add(this.longestTermLength, 'months').date(0)
      let months = [];

      while (endMonth > startMonth) {
        months.push(startMonth.format('YYYY-MM-DD'))
        startMonth.add(1, 'month')
      }

      return months
    },
    setDate() {
      this.$store.dispatch('setStartMonth', this.selectedTimestamp.format('YYYY-MM-DD'))

      if (this.customFacilityProfileSet) {
        // A previous custom profile exists,
        // so we need to determine whether the new start month comes
        // before or after the previous start month
        this.updateCustomFacilityProfile(false)
          
      } else if (this.tempcustomFacilityProfileSet) {
        // A previous custom profile was started but not submitted
        this.updateCustomFacilityProfile(true)
      }
    },
    updateCustomFacilityProfile(isTemp) {

      // Transfer Month Values:
      let monthRange = this.getMonthRange(this.selectedTimestamp)
      let months = []

      for (let i = 0; i < monthRange.length; ++i) {

        let month = {}
        let previousMonth

        if (isTemp) {
          previousMonth = this.tempCustomFacilityProfile.months.filter(obj => {
            return obj.month === monthRange[i]
          })

        } else {
          previousMonth = this.customFacilityProfile.months.filter(obj => {
            return obj.month === monthRange[i]
          })
        }

        if (previousMonth.length > 0) {
          month = {
            month: monthRange[i],
            usage: previousMonth[0].usage,
            onPeakUsage: previousMonth[0].onPeakUsage,
            onPeakUsagePercent: previousMonth[0].onPeakUsagePercent,
            offPeakUsage: previousMonth[0].offPeakUsage,
            peakDemand: previousMonth[0].peakDemand
          }

        } else {
          month = {
            month: monthRange[i],
            usage: '',
            onPeakUsage: '',
            onPeakUsagePercent: null,
            offPeakUsage: '',
            peakDemand: ''
          }
        }

        months.push(month)
      }

      // Transfer Extra Column Values:
      let previousExtraColumns = (isTemp) 
        ? this.tempCustomFacilityProfile.extraColumns 
        : this.customFacilityProfile.extraColumns

      let extraColumns = []

      if (previousExtraColumns.length > 0) {

        for (let i = 0; i < previousExtraColumns.length; ++i) {

          let monthRange = this.getMonthRange(this.selectedTimestamp)
          let months = []
          let valueRanges = []

          for (let x = 0; x < monthRange.length; ++x) {

            let previousMonth = previousExtraColumns[i].months.filter(obj => {
              return obj.month === monthRange[x]
            })

            let month = {}

            if (previousMonth.length > 0) {

              month = {
                month: monthRange[x],
                value: previousMonth[0].value
              }
            } else {

              month = {
                month: monthRange[x],
                value: 0
              }
            }

            months.push(month)
          }

          if (previousExtraColumns[i].valueRanges != null && previousExtraColumns[i].valueRanges.length > 0) {

            let newStartMonth = new moment(this.selectedTimestamp).toDate()
            let newEndMonth = new moment(this.selectedTimestamp).add(this.longestTermLength, 'months').date(0).toDate()

            for (let y = 0; y < previousExtraColumns[i].valueRanges.length; ++y) {

              // Inspect each value range
              let previousStartMonth = new moment(previousExtraColumns[i].valueRanges[y].startMonth).toDate()
              let previousEndMonth = new moment(previousExtraColumns[i].valueRanges[y].endMonth).toDate()

              // If the value range falls within the new overall range, save it
              if (moment(previousStartMonth).isBetween(newStartMonth, newEndMonth) && moment(previousEndMonth).isBetween(newStartMonth, newEndMonth)) {

                let range = {
                  value: previousExtraColumns[i].valueRanges[y].value,
                  startMonth: previousExtraColumns[i].valueRanges[y].startMonth,
                  endMonth: previousExtraColumns[i].valueRanges[y].endMonth
                }

                valueRanges.push(range)

                continue
              }

              // If the old range straddles new start month, set range start month equal to new start month
              if (moment(previousStartMonth).isBefore(newStartMonth) && moment(previousEndMonth).isAfter(newStartMonth)) {

                let range = {
                  value: previousExtraColumns[i].valueRanges[y].value,
                  startMonth: newStartMonth,
                  endMonth: previousExtraColumns[i].valueRanges[y].endMonth
                }

                valueRanges.push(range)

                continue
              }

              // If the old range straddles new end month, set range end month equal to new end month
              if (moment(previousStartMonth).isBefore(newEndMonth) && moment(previousEndMonth).isAfter(newEndMonth)) {

                let range = {
                  value: previousExtraColumns[i].valueRanges[y].value,
                  startMonth: previousExtraColumns[i].valueRanges[y].startMonth,
                  endMonth: newEndMonth
                }

                valueRanges.push(range)

                continue
              }
            }
          }

          extraColumns[i] = {
            id: previousExtraColumns[i].id, 
            name: previousExtraColumns[i].name, 
            abbrev: previousExtraColumns[i].abbrev, 
            type: previousExtraColumns[i].type,
            months: months,
            valueRanges: valueRanges
          }
        }
      }

      // Recalculate Total:
      let total = {
        usage: 0,
        onPeakUsage: 0,
        offPeakUsage: 0
      }

      for (let i = 0; i < months.length; ++i) {
        if (months[i].usage) {
          total.usage = total.usage + parseInt(months[i].usage)
        }

        if (months[i].onPeakUsage) {
          total.onPeakUsage = total.onPeakUsage + parseInt(months[i].onPeakUsage)
        }

        if (months[i].offPeakUsage) {
          total.offPeakUsage = total.offPeakUsage + parseInt(months[i].offPeakUsage)
        }
      }

      // Update Profile:
      let saveAction = (isTemp)
        ? 'setTempCustomFacilityProfile' 
        : 'setCustomFacilityProfile'

      this.$store.dispatch(saveAction, {
        months: months,
        total: total,
        extraColumns: extraColumns
      })
    }
  },
  mounted() {
    if (this.startMonth) {
      this.selected.month = moment(this.startMonth).format('M')
      this.selected.year  = moment(this.startMonth).format('YYYY')

      if (this.selected.month <= moment(this.now).format('M')) {
        this.invalidYears.push(moment(this.now).format('YYYY'))
      }
    }

    if (this.selected.year) {
      this.validateYears(true)
    } 
  } 
}
</script>
